"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=require("styled-components"),r=require("@vds-core/utilities"),l=require("@vds-core/typography");function a(e){return e&&e.__esModule?e:{default:e}}var o=a(e);const i=a(t).default.div.withConfig({displayName:"InputTextWrapper",componentId:"VDS__sc-r9e0ad-0"})`
  display: block;
  margin-top: ${r.calculateRem(8)};
`;exports.default=({children:e,fontFamily:t,color:r})=>o.default.createElement("div",{role:"alert"},o.default.createElement(i,null,o.default.createElement(l.Body,{size:"small",fontFamily:t&&t,color:r},e)));



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/checkboxes/cjs/components/InputText.js
// module id = 907
// module chunks = 0